/*!
 * JavaScript Cookie v2.0.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        /*var _OldCookies = window.Cookies;
         var api = window.Cookies = factory();
         api.noConflict = function () {
         window.Cookies = _OldCookies;
         return api;
         };*/
        window.FF_Cookie = factory();
    }
}(function () {
    function extend () {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
            var attributes = arguments[ i ];
            for (var key in attributes) {
                result[key] = attributes[key];
            }
        }
        return result;
    }

    function init (converter) {
        function api (key, value, attributes) {
            var result;

            // Write

            if (arguments.length > 1) {
                attributes = extend({
                    path: '/'
                }, api.defaults, attributes);

                if (typeof attributes.expires === 'number') {
                    var expires = new Date();
                    expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
                    attributes.expires = expires;
                }

                try {
                    result = JSON.stringify(value);
                    if (/^[\{\[]/.test(result)) {
                        value = result;
                    }
                } catch (e) {}

                if (!converter.write) {
                    value = encodeURIComponent(String(value))
                        .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
                } else {
                    value = converter.write(value, key);
                }

                key = encodeURIComponent(String(key));
                key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
                key = key.replace(/[\(\)]/g, escape);

                return (document.cookie = [
                    key, '=', value,
                    attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
                    attributes.path    && '; path=' + attributes.path,
                    attributes.domain  && '; domain=' + attributes.domain,
                    attributes.secure ? '; secure' : ''
                ].join(''));
            }

            // Read

            if (!key) {
                result = {};
            }

            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all. Also prevents odd result when
            // calling "get()"
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var rdecode = /(%[0-9A-Z]{2})+/g;
            var i = 0;

            for (; i < cookies.length; i++) {
                var parts = cookies[i].split('=');
                var name = parts[0].replace(rdecode, decodeURIComponent);
                var cookie = parts.slice(1).join('=');

                if (cookie.charAt(0) === '"') {
                    cookie = cookie.slice(1, -1);
                }

                try {
                    cookie = converter.read ?
                        converter.read(cookie, name) : converter(cookie, name) ||
                    cookie.replace(rdecode, decodeURIComponent);

                    if (this.json) {
                        try {
                            cookie = JSON.parse(cookie);
                        } catch (e) {}
                    }

                    if (key === name) {
                        result = cookie;
                        break;
                    }

                    if (!key) {
                        result[name] = cookie;
                    }
                } catch (e) {}
            }

            return result;
        }

        api.get = api.set = api;
        api.getJSON = function () {
            return api.apply({
                json: true
            }, [].slice.call(arguments));
        };
        api.defaults = {};

        api.remove = function (key, attributes) {
            api(key, '', extend(attributes, {
                expires: -1
            }));
        };

        api.withConverter = init;

        return api;
    }

    return init(function () {});
}));

jQuery(function ($) {

    var $win = $(window);
    var $body = $('body');

    // DOM manipulations

    $('#sf_font').after($('#sf_uppercase_chooser')).after($('#sf_font_weight_chooser')).after($('#sf_alignment_chooser')).after($('#sf_font_size'))

    $('#sf_c_font').after($('#sf_c_trans_chooser')).after($('#sf_c_weight_chooser')).after($('#sf_c_fs'));

    $('#sf_c_fs').after('<span class="units" style="top:-16px">px</span><br>');
    $('#sf_font_size').after('<span class="units" style="top:-16px">px</span><br>');

    $('.sf_font').find('p:empty').remove();
    $('.sf_c_font').find('p:empty').remove();

    $('.switcher').each(function () {
        $(this).after('<div><div></div></div>')
    })

    $('.postbox select').each(function () {
        var id = this.id
        $(this).wrap('<div class="select-wrapper" id="' + id + '-wrapper"></div>')
    })

    $('[id*=sf_width_panel_]').each(function () {
        var ind = this.id.replace('sf_width_panel_', '');
        var cl = $('#sf_color_panel_' + ind);
        var scl = $('#sf_scolor_panel_' + ind);
        var bg = $('#sf_bg_color_panel_' + ind);
        var cc = $('#sf_chapter_' + ind);
        var hover = $('#sf_hover_panel_' + ind);
        $(this).parent().append(bg).append(cl).append(scl).append(cc).append(hover);
        bg.before('<span>Background</span>');
        cl.before('<span>Text</span>');
        scl.before('<span>Second line</span>');
        hover.before('<span>Hover color</span>');
        cc.before('<span>Section</span>');
    })

    // adding export / import button
    var html = '<div class="settings-form-row sf_export"><p class="field-title ">EXPORT / IMPORT DESIGN SETTINGS</p><h6>Please notice that import action cannot be reverted. Export doesn\'t include WP menus or any images, icons from this site</h6><p><a class="button-ui" href="/wp-admin/admin-post.php?action=sf_export_settings&data=admin_only">Export</a>&nbsp;&nbsp;&nbsp;<a href="#" class="button-ui" id="sf-import-btn">Import</a>&nbsp;&nbsp;&nbsp;<input type="file" id="sf_files" accept=".json,application/json"></p></div>';

    $('.sf_css').prepend( $( html ) );

    // SUBSCRIPTION CHECK

    var subCookie = window.FF_Cookie.get('sfm_sub');

    if ( subCookie ) {

    } else {
        if ( $('#sf_license_subscribe').prop('checked') ) {

            var $licenseCont = $('#sf_license');
            var fname = $('#sf_license_fname', $licenseCont).val();
            var lname = $('#sf_license_lname', $licenseCont).val();
            var email = $('#sf_license_email', $licenseCont).val();

            var data = {
                action: 'subscribe',
                email: email,
                fname: fname,
                lname: lname
            }

            var url = 'https://looks-awesome.com/proxy/superfly-mailchimp.php';

            $.post(url, data, function (response) {});

            window.FF_Cookie.set('sfm_sub', 'attempted', { expires: 356 });
        }
    }

    // Events

    $('#sf_sidebar_style').change(function () {
        var val = $(this).val();
        var $w = $(this).closest('.settings-form-row');

        $w.find('[data-notice]').hide().end().find('[data-notice=' + val + ']').show();
        if (val === 'static') {
            $('.sf_iconbar').show()
        } else {
            $('.sf_iconbar').hide()
        }

        if (val === 'full') {
            $('.sf_fade_content').hide();
            $('.sf_fade_full').show();
        } else {
            $('.sf_fade_content').show();
            $('.sf_fade_full').hide();
        }
    }).change();

    var initEmail = $('#sf_license #sf_license_email').val();
    var initCode = $('#sf_license #sf_license_code').val();

    function validateLicense() {
        var $licenseCont = $('#sf_license');
        var activated = $('#sf_license_valid', $licenseCont).val();
        var fname = $('#sf_license_fname', $licenseCont).val();
        var lname = $('#sf_license_lname', $licenseCont).val();
        var email = $('#sf_license_email', $licenseCont).val();
        var subscribe = $('#sf_license_subscribe', $licenseCont).prop('checked');
        var code = $('#sf_license_code', $licenseCont).length > 0 ? $('#sf_license_code', $licenseCont).val() : '';
        var isX = $('#sf_license_code', $licenseCont).data('x');
        var licenseValid = true;
        var dfd = $.Deferred();
        var data;

        $('#sf_license_email', $licenseCont).removeClass('validation-error');
        $('#sf_license_code', $licenseCont).removeClass('validation-error');
        $('.purchase-code .code-error', $licenseCont).hide();

        /*if(fname !== '' || lname !==  ''){
            licenseValid = false;

            if(email === ''){
                $('#sf_license_email', $licenseCont).addClass('validation-error');
            }

            if(code === ''){
                $('#sf_license_code', $licenseCont).addClass('validation-error');
            }
        }*/


        if(email == '' && code != '' && !isX){
            $('#sf_license_email', $licenseCont).addClass('validation-error');
            licenseValid = false;
        }

        /*if(email == '' && isX){
            $('#sf_license_email', $licenseCont).addClass('validation-error');
            licenseValid = false;
        }*/

        if (activated && email == initEmail && code == initCode) {
            dfd.resolve(activated);
            return dfd.promise();
        }

        if (email != '') {
            if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(email)) {
                $('#sf_license_email', $licenseCont).addClass('validation-error');
                licenseValid = false;
            } else {
                if($('#sf_license_code', $licenseCont).length === 0){

                }
                data = {
                    action: 'always',
                    email: email,
                    fname: fname,
                    lname: lname
                };
                var url = 'https://looks-awesome.com/proxy/superfly-mailchimp.php';

                // Subscribe to list (anyway)
                $.post(url, data, function (response) {});
                if (subscribe) {
                    data.action = 'subscribe';
                    // Subscribe to public list (only if checkbox selected)
                    $.post(url, data, function (response) {});
                }
            }
        }

        if (code != '') {
            var regexTest = /^[a-z0-9]+\-[a-z0-9]+\-[a-z0-9]+\-[a-z0-9]+\-[a-z0-9]+$/.test(code);

            if (!regexTest) {
                $('#sf_license_code', $licenseCont).addClass('validation-error');
                licenseValid = regexTest;
                dfd.resolve(licenseValid);
                $('#for_sf_license').trigger('click');
            } else {
                data = {
                    action: 'sf_validate_envato_license',
                    code: code
                };

                $.post(laim_localize.ajaxurl, data, function (response) {
                    if (response == -1) {
                        licenseValid = false;
                    } else {
                        if (response.error || response.item_id !== "8012790") {
                            licenseValid = false;
                            $('#sf_license_code', $licenseCont).addClass('validation-error');
                            $('.purchase-code .code-error', $licenseCont).show();
                            $('#for_sf_license').trigger('click');
                        } else {
                            $('#sf_license_valid', $licenseCont).val('1');
                        }
                    }
                    dfd.resolve(licenseValid);
                });
            }
        } else {
            dfd.resolve(licenseValid);
        }

        return dfd.promise();
    }

    $('#sf_license_code').on('input', function (e, options) {
        $('#sf_license_valid').val('');
        $(this).removeClass('validation-success');
    });

    $('#sf_license_email').on('input', function (e, options) {
        //$('#sf_license_valid').val('');
    });

    $('#sf_license_subscribe').on('change', function (e, options) {
        //$('#sf_license_valid').val('');
    });

    $('#sf-options-wrap form').on('submit', function (e, options) {
        options = options || {};
        if (!options.flag) {
            e.preventDefault();
        }

        var $form = $(this);
        var p = $('.sf_display');
        var current = p.find('.loc_popup')
        var hidden = p.find('input:hidden');
        var user = current.find('select[id*=user_status]').val();
        var rule = current.find('select[id*=display_rule]').val();
        var desktop = current.find('select[id*=display_desktop]').val();
        var mobile = current.find('select[id*=display_mobile]').val();
        var ids = current.find('[id*=display_ids]').val();

        var resulted = {
            'user': {
                'everyone': user === 'everyone' ? 1 : 0,
                'loggedin': user === 'loggedin' ? 1 : 0,
                'loggedout': user === 'loggedout' ? 1 : 0
            },
            'desktop': {
                'yes': desktop === 'yes' ? 1 : 0,
                'no': desktop === 'no' ? 1 : 0
            },
            'mobile': {
                'yes': mobile === 'yes' ? 1 : 0,
                'no': mobile === 'no' ? 1 : 0
            },

            'rule': {
                // 'include': rule === 'include' ? 1 : 0,
                // 'exclude': rule === 'exclude' ? 1 : 0
                'include': 0,
                'exclude': 1
            },
            'location': {
                'pages': traversePages(current.find('input[id*=display_page]')),
                'cposts': traversePages(current.find('input[id*=display_cpost]')),
                'cats': traversePages(current.find('input[id*=display_cat]')),
                'taxes': {},
                'langs': traversePages(current.find('input[id*=display_lang]')),
                'wp_pages': traversePages(current.find('input[id*=display_wp_page]')),
                'ids': ids.split(',')
            }
        };
        hidden.val(JSON.stringify(resulted));
        showLoadingView();

        if (!options.flag) {
            validateLicense().done(function (data) {
                if (data) {
                    showLoadingView();
                    $form.trigger('submit', {flag: true});
                } else {
                    hideLoadingView();
                    e.preventDefault();
                }
            });
        }
    });
    
    
    // import 
    
    $( '#sf-import-btn' ).click( function () {
        var $inp = $( '#sf_files' )
        $inp.click();
    })

    $( '#sf_files' ).change( function () {
        var file;
        var reader = new FileReader();

        if ( !this.files ) {
            alert( 'Sorry your browser does not support files API' );
            return;
        }
        if ( !this.files[0] ) {
            alert( 'No file selected' );
            return;
        }

        file = this.files[0];

        reader.onload = (function ( file ) {
            return function (e) {
                var json;

                try {
                    json = JSON.parse( e.target.result) ;
                } catch ( er ) {
                    alert('ex when trying to parse json = ' + er);
                }

                console.log( json );

                if ( confirm('Are you sure you want to apply imported settings? This action cannot be reverted')) {
                    $.post( '/wp-admin/admin-post.php', {
                        action: 'sf_import_settings',
                        data: json,
                        dataType: 'json'
                    }).done( function ( data ) {
                        console.log( data );
                        location.reload( );
                    }).fail( function () {
                        alert( "request error" );
                    })
                }
            }
        })( file );

        reader.readAsText( file );

    })


    function traversePages(pages) {
        var res = {};

        pages.each(function (i, el) {
            var t = $(el);
            var val = t.val();
            if (t.is(':checked')) res[val] = 1;
        });

        return res
    }

    function showLoadingView() {
        $('#fade-overlay').addClass('loading');
    }

    function hideLoadingView() {
        $('#fade-overlay').removeClass('loading');
    }


    function isScrolledIntoView($elem, elemTop, elemBottom, rule) {
        var docViewTop = $win.scrollTop();
        var docViewBottom = docViewTop + $win.height();

        return rule === 'after' ? docViewBottom > elemBottom + 50 : (elemBottom <= docViewBottom && elemTop >= docViewTop - 25) || (elemBottom > docViewBottom && elemTop < docViewTop - 25);
    }

    var state = 'in';
    var $tabs = $('#tabs-copy');
    var $subtabs = $('#sf_appearance_tabs');
    var $or = $('#tabs');
    var $form = $('#sf-options-wrap form')

    $win.scroll(function () {

        var elemTop = $tabs.offset().top;
        var elemBottom = elemTop + $tabs.height();
        if (isScrolledIntoView($tabs, elemTop, elemBottom, 'in')) {
            if (state !== 'in') {
                state = 'in';
                $or.removeClass('transition-in');
                //setTimeout(function () {
                $body.removeClass('fixed-nav');
                $or.css({'width': '', left: ''});
                //}, 50)
            }
        } else {
            if (state !== 'out') {
                state = 'out';
                $body.addClass('fixed-nav');
                $or.css({'width': $tabs.width(), left: $form.offset().left});
                $subtabs.css({'width': $tabs.width(), left: $form.offset().left});
                //setTimeout(function () {
                $or.addClass('transition-in');
                //}, 100)
            }
        }

    });

    $win.resize(function () {
        if ($body.is('.fixed-nav')) {
            $or.css({'width': $tabs.width(), left: $form.offset().left})
        }
    })

    $or.find('li').not('#save-tab').click(function () {
        $('html,body').animate({
            scrollTop: 0
        }, 300);
    });

    $subtabs.click(function () {
        $('html,body').animate({
            scrollTop: 0
        }, 300);
    });

    $('#save-tab').click(function () {
        $(this).closest('form').submit();
    })

    $('#form-tab').click(function () {

    })

    var file_frame, attachment, $input;

    $('.sf-choose-image').click(function () {
        var $t = $(this);
        $input = $t.parents('.settings-form-row').eq(0).find('input');
        if (file_frame) {
            file_frame.open();
            return;
        }

        // Create the media frame.
        file_frame = wp.media.frames.file_frame = wp.media({
            multiple: false  // Set to true to allow multiple files to be selected
        });

        // When an image is selected, run a callback.
        file_frame.on('select', function () {
            // We set multiple to false so only get one image from the uploader

            attachment = file_frame.state().get('selection').first().toJSON();
            $('.image-preview').html('<img src="' + attachment.url + '"/>');
            if (!$('.sf-remove-image').length) $t.parent().after("<div><span class='sf-remove-image'>Remove Image</span></div>");
            $input.val(attachment.sizes.full.url);
            $input.closest('form').submit()
//      $currBtn = null;
        });

        // Finally, open the modal
        file_frame.open();
    })

    $(document).on('click', '.sf-remove-image', function () {
        var $t = $(this);
        $input = $t.parents('.settings-form-row').eq(0).find('input');
        $input.val('');
        $(this).closest('form').submit()
    })


    // multiple menus

    var $select = $('#sf-menu__select-wrapper ');
    var $popup, $locPopup, $clone, $def;
    var $storageInput = $('.sf_active_menu input');
    var $list = $('.sf-menu__list');

    // dom
    $select.wrap('<div class="sf-menu__select_popup"></div>');
    $popup = $('.sf-menu__select_popup');
    $popup.append('<span class="sf-menu__btn sf-menu__btn__ok"><i class="flaticon-plus"></i></span><span class="sf-menu__btn sf-menu__btn__close"><i class="flaticon-cross"></i></span>');

    $clone = $('.loc_popup > div').clone();

    $clone.find('.rule_lang').remove();

    $clone.find('[id]').each(function () {
        var id = $(this).attr('id');
        $(this).attr('id', id + '_popup')
    });
    $clone.find('[for]').each(function () {
        var _for = $(this).attr('for');
        $(this).attr('for', _for + '_popup')
    });

    $clone.addClass('sf-menu__loc_popup').prepend('\
        <div class="sf-menu__def_wrapper"><p>Mark pages of your website to display this menu.</p>\
        <p>\
            <input class="checkbox" type="checkbox" value="yes" id="display_default_menu_popup" name="display_default_menu">\
            <label for="display_default_menu_popup">Display everywhere by default. / General display rules may overwrite this setting</label>\
        </p>\
        </div>\
    ');

    $('.dw_pages_wrap', $clone).prepend('\
    <div><span class="sf-menu__loc_btn_check_all">Check All</span> <span class="sf-menu__loc_btn_check_none">Uncheck All</span></div>\
    ')

    $clone.addClass('sf-menu__loc_popup').append('<span class="sf-menu__loc_btn_save">Save</span> <span class="sf-menu__loc_btn_close">Close</span>')

    $popup.after($clone);

    $(document).on('click', '.sf-menu__loc_btn_check_all', function () {
        $('.sf-menu__loc_popup input[type="checkbox"][name!="display_default_menu"]').prop('checked', true);
    });
    $(document).on('click', '.sf-menu__loc_btn_check_none', function () {
        $('.sf-menu__loc_popup input[type="checkbox"][name!="display_default_menu"]').prop('checked', false);
    });
    $(document).on('change', '[name="display_default_menu"]', function (e) {
        $('.sf-menu__loc_popup .dw_pages_wrap').show();
        if($(this).prop('checked'))
            $('.sf-menu__loc_popup .dw_pages_wrap').hide();
    });


    $locPopup = $('.sf-menu__loc_popup');
    $def = $locPopup.find('#display_default_menu_popup');

    //$locPopup.find('#display_ids_popup').parent().hide();

    $list.find('.sf-menu__item').each(function () {
        var $t = $(this);
        var id = $t.data('id');
        var location;
        var curr = window.sf_menus[id];
        if (curr) {
            location = curr['loc'];
            $t.data('location', location);
            $t.data('isDef', curr['isDef']);
        }
    })

    $('.sf-menu__add').click(function () {
        $(this).closest('.sf_active_menu').addClass('sf_active_menu--selecting');
    })

    $('.sf-menu__btn__ok').click(function () {
        var val = $select.find('select').val();
        var $selected = $select.find(':selected');

        var $item;
        console.log(val);

        // check if added
        if ($list.find('[data-id=' + val + ']').length) {
            alert('Already added!');
            return;
        }

        $item = $('<li class="sf-menu__item" data-id="' + val + '">' + $selected.text() + '<i class="flaticon-cross"></i></li>');
        $list.append($item);


        updateMenuMap();

        if ($list.find('.sf-menu__item').length === 1) { // single item
            openLocPopup($item);
            $locPopup.find(':checkbox').prop('checked', true)
            $locPopup.find('.sf-menu__loc_btn_save').click();
            closeLocPopup({target: null}, true);
            return;
        }
        $(this).closest('form').submit()


    })

    $('.sf-menu__btn__close').click(function () {
        $(this).closest('.sf_active_menu').removeClass('sf_active_menu--selecting');
    })

    $list.on('click', '.sf-menu__item', function (e) {
        var $t = $(e.target);
        var $form = $t.closest('form');

        if ($t.is('.flaticon-cross')) {
            $t.closest('.sf-menu__item').remove();
            updateMenuMap();
            $form.closest('form').submit();
            return;
        }

        console.log('open loc popup');
        openLocPopup($t.closest('.sf-menu__item'))
    })

    $locPopup.on('click', '.sf-menu__loc_btn_save', function () {
        var current = $locPopup;
        var ids = current.find('[id*=display_ids]').val();
        var $item = $locPopup.data('currentItem');

        var location = {
            'pages': traversePages(current.find('input[id*=display_page]')),
            'cposts': traversePages(current.find('input[id*=display_cpost]')),
            'cats': traversePages(current.find('input[id*=display_cat]')),
            'taxes': {},
            'langs': traversePages(current.find('input[id*=display_lang]')),
            'wp_pages': traversePages(current.find('input[id*=display_wp_page]')),
            'ids': ids.split(',')
        };

        $item.data('location', location);
        $item.data('isDef', $def.is(':checked'));

        updateMenuMap();

        current.closest('form').submit()

    });

    $def.on('change', function (e) {
        var $curr;

        // check if already default is set
        $list.find('.sf-menu__item').each(function () {
            var $t = $(this);
            if ($t.data('isDef')) {
                $curr = $t;
            }
        });

        if ($curr && $curr.data('id') != $locPopup.data('currentItem').data('id')) {
            $def.attr('checked', false);
            alert('You already have default menu. Please edit this menu before and uncheck this property.');
            return false;
        }
    })

    $locPopup.on('click', '.sf-menu__loc_btn_close', closeLocPopup)

    function updateMenuMap() {
        var $items = $list.find('.sf-menu__item');
        var map = {};
        $items.each(function () {
            var $t = $(this);
            var locationData = $t.data('location') || {};

            map[$t.data('id')] = {
                term_id: $t.data('id'),
                name: $.trim($t.text()),
                loc: locationData,
                isDef: $t.data('isDef')
            }
        })
        $storageInput.val(JSON.stringify(map));
    }

    function openLocPopup($item) {
        // attempt to retrieve date
        var locationData = $item.data('location');
        $locPopup.data('currentItem', $item);

        // reset
        $locPopup.find(':checked').prop('checked', false)
        $locPopup.find(':text').val('');

        if (locationData) {
            populatePopup(locationData, $item);
        }

        $def.prop('checked', $item.data('isDef'))
        if($item.data('isDef')){
            $('.dw_pages_wrap', $locPopup).hide();
        }else{
            $('.dw_pages_wrap', $locPopup).show();
        }

        setTimeout(function () {
            $body.on('click', closeLocPopup)
        }, 0)


        $item.closest('.sf_active_menu').addClass('sf_active_menu--editing')
    }

    function closeLocPopup(e, force) {
        var $t = $(e.target);
        if (!$t.closest($locPopup).length || $t.is('.sf-menu__loc_btn_close') || force) {
            $('.sf_active_menu').removeClass('sf_active_menu--editing');
            $body.off('click', closeLocPopup)
        }
    }

    function populatePopup(location, current) {
        var prop, cat;

        for (prop in location) {
            cat = location[prop];
            for (var name in cat) {
                $locPopup.find('#display_' + prop.replace(/s$/, '') + '_' + name + '_popup').prop('checked', location[prop]);
            }
        }

        $locPopup.find('#display_ids_popup').val(location.ids.join(','));
    }

    $body.addClass('page-loaded');

})